export default __webpack_public_path__ + "static/media/goldbackground.ac4563d5.jpg";